import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';
import Typography from '@mui/material/Typography';
// import { Stack } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
// import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import Stack from '@mui/material/Stack';
import { Box, CardActions } from '@mui/material';
// import LaunchIcon from '@mui/icons-material/Launch';
import Chip from '@mui/material/Chip';
// import { useTheme } from '@mui/material/styles';
// import { createTheme } from '@mui/material';
// import { Link, NavLink } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
// import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';
import { ScrollTypography } from '../../Styles';
// import LanguageIcon from '@mui/icons-material/Language';
import TranslateOutlinedIcon from '@mui/icons-material/TranslateOutlined';
// import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';
// import CardActions from '@mui/material/CardActions';
// import { CardActionArea } from '@mui/material';
import { encryptData } from '../../Utils';

// import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import dayjs from 'dayjs';




function NewRequestlist(props) {  //new assignment list //dashboard
    let navigate = useNavigate();
    var card_request_time = props.assign_data.assign_request_time_only.trim();

    const openListnavigateList = (assign_id) => {
        navigate("/Interpreter/Assignment_Acceptence/" + assign_id);
    }
    return (

        <Grid xs={12} sm={6} md={6}   >
            <Card sx={{ backgroundColor: '#fff', borderRadius: '10px', cursor: 'pointer' }} elevation={0} onClick={() => openListnavigateList(props.assign_data.assign_id)}>

            <CardContent sx={{ padding: { xs: '5px', sm: '7px', md: '8px' }, height: { xs: '110px', sm: '120px', md: '125px' } }}  >
                    <Grid container spacing={1} >
                        <Grid xs={4} sm={4} md={4}  >
                            <Card sx={{ backgroundColor: props.appThemeColor, borderRadius: '15px', height: { xs: '80%', sm: '85%' } }}>
                                <CardContent sx={{ padding: { xs: '7px', sm: '7px', md: '8px' } }}>
                                    <Typography sx={{ fontSize: { xs: '12px', sm: '13px' }}} color='#fff'> {props.assign_data.assign_request_day}</Typography>
                                    <Typography sx={{ typography: { xs: 'h4', sm: 'h4' }, mb: -1 }} color={props.cardTheme.colors.text}>{props.assign_data.assign_request_date_only}</Typography>
                                    <Box sx={ScrollTypography}> <Typography color={props.cardTheme.colors.text} sx={{ whiteSpace: 'nowrap', typography: { xs: 'body2', sm: 'body2', md: 'subtitle1' } }}  >{props.assign_data.assign_request_month_with_year}</Typography>
                                    </Box>

                                    <Box sx={{ display: 'flex', alignItems: 'center', mt: 0.5 }}>
                                        <AccessTimeRoundedIcon sx={{ color: 'white', fontSize: { xs: '15px', sm: '16px', md: '20px' }, ml: '-2px', mr: 0.2 }} /> <Typography sx={{ whiteSpace: 'nowrap', typography: { xs: 'caption', sm: 'subtitle2', md: 'subtitle1' } }} color={props.cardTheme.colors.text}  > {card_request_time}</Typography>
                                    </Box>

                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid xs={8} sm={8} md={8}>
                            <Stack spacing={1} direction='row'>
                                <Box sx={ScrollTypography}> <Typography variant='subtitle1' sx={{ letterSpacing: '-0.2px', whiteSpace: 'nowrap', fontWeight: 'bold' }}>{props.assign_data.assign_order_id}</ Typography></Box>
                                <Box> {props.assign_data.assign_applicant_counts === 1 && <Chip label={<Typography variant='caption' sx={{ whiteSpace: 'nowrap' }}>Only to You</Typography>} size="small" sx={{ backgroundColor: '#89B601', color: '#fff', borderRadius: 2, height: '18px' }} />} </Box>
                            </Stack>

                            <Typography sx={{ letterSpacing: '-0.2px', typography: { xs: 'body2', sm: 'body1' } }} color={props.appThemeColor} >{props.assign_data.assign_industry_name}</Typography>
                            <Typography color={props.appThemeColor} sx={{ typography: { xs: 'caption', sm: 'subtitle2', md: 'subtitle1' }, whiteSpace: 'nowrap' }} style={{ letterSpacing: '-0.3px' }}  >{props.assign_data.service_type} | {props.assign_data.service_mode}</Typography>

                            <Stack direction='row'>
                                <Box sx={{ display: 'flex', alignItems: 'center', ml: '-15px' }}>
                                    <TranslateOutlinedIcon sx={{ fontSize: { xs: '15px', sm: '16px', md: '20px' }, ml: 2, mr: 0.2 }} /><Typography style={{ letterSpacing: '-1px' }} sx={{ typography: { xs: 'caption', sm: 'subtitle2', md: 'subtitle1' }, whiteSpace: 'nowrap' }} color={props.appThemeColor} >  {props.assign_data.language_name}</Typography>
                                </Box>

                                <Box sx={{ display: 'flex', alignItems: 'center', }}>
                                    <AccessTimeRoundedIcon sx={{ fontSize: { xs: '15px', sm: '16px', md: '20px' }, ml: 2, mr: 0.2 }} /><Typography style={{ letterSpacing: '-1px' }} sx={{ typography: { xs: 'caption', sm: 'subtitle2', md: 'subtitle1' }, whiteSpace: 'nowrap' }} color={props.appThemeColor} > {props.assign_data.assign_duration}</Typography>
                                </Box>
                            </Stack>
                        </Grid>

                    </Grid>
                </CardContent>
                <CardActions sx={{ display: 'block', padding: 0 }}>
                    <Typography align='center' style={{ fontWeight: 'normal' }} sx={{ letterSpacing: '-0.2px', typography: { xs: 'caption', sm: 'subtitle2', md: 'subtitle1' } }}   >{props.assign_data.assign_applied_timezone_daylight}</Typography>

                </CardActions>


            </Card>
        </Grid>

    )
}

function AssignmentsStatusList(props) {  //assignment status list
    let orderidBadgeShowValue = "";
    let navigate = useNavigate();
    var card_request_time = props.assign_data.assign_request_time_only.trim();
    let CardBgColor = props.appThemeColor;
    if (props.assignStatus === "inprogress") {
        CardBgColor = props.appThemeColor;   //Card Colours
        if (props.assign_data.assign_interpreter_count === 1) orderidBadgeShowValue = "Only to You";
    }
    else if (props.assignStatus === "upcoming") {
        CardBgColor = "#89B601";
        orderidBadgeShowValue = (props.assign_data.assign_post_status === 'Lapsed') ? 'Lapsed' : '';
    }
    else if (props.assignStatus === "active") {
        CardBgColor = "#0793dd";
    }
    else if (props.assignStatus === "lapsed") {
        CardBgColor = "#F0AD4E";
    }
    else if (props.assignStatus === "completed") {
        CardBgColor = "#009F96";
        orderidBadgeShowValue = props.assign_data.assign_bill_status;
    }
    else if (props.assignStatus === "cancelled") CardBgColor = "#ff4c3b";
    else if (props.assignStatus === "withdrawn") CardBgColor = "#726aca";



    const openListnavigateList = (assign_id, assign_cancel_id) => {
        let get_thirdsegment = window.location.pathname.split('/')[2];
        if (get_thirdsegment === "Completed_list") {
            navigate("/Interpreter/Assignment_DetailPage/" + assign_id + "/" + encodeURIComponent(encryptData(get_thirdsegment)));
        } else if (get_thirdsegment === "Cancelled_list") {
            navigate("/Interpreter/Assignment_DetailPage/" + assign_id + "/" + encodeURIComponent(encryptData(get_thirdsegment)) + "/" + assign_cancel_id);
        } else if (get_thirdsegment === "Withdrawn_list") {
            navigate("/Interpreter/Withdrawn_list");
        }  else if (
            props.assignStatus === "verification" ||
            (props.assignStatus === "action" &&
                props.assign_data.page_status === "verification")
        ) {
            navigate("/Interpreter/Assignment_Acceptence/" + assign_id + "/verification");
        }
        else if (get_thirdsegment === "Billed_list") {
            navigate("/Interpreter/Assignment_DetailPage/" + assign_id + "/" + encodeURIComponent(encryptData(get_thirdsegment)));
       }
       
else if (
    props.assignStatus === "lapsed" ||
    (props.assignStatus === "action" && props.assign_data.page_status === "Lapsed_list")
) {

    var page_status = "Lapsed_list";

    navigate(
        "/Interpreter/Assignment_Acceptence/" +
        assign_id +
        "/" +
        encodeURIComponent(encryptData(page_status))
    );
}

        else {
            navigate("/Interpreter/Assignment_Acceptence/" + assign_id + "/" + encodeURIComponent(encryptData(get_thirdsegment)));
        }
    }

    return (
        <Grid xs={12} sm={6} md={6} >
            <Card sx={{ backgroundColor: '#fff', borderRadius: '10px', cursor: 'pointer' }} elevation={0} onClick={() => openListnavigateList(props.assign_data.assign_id, props.assign_data.assign_cancel_id)}>

                <CardContent sx={{ padding: { xs: '5px', sm: '7px', md: '8px' } }}  >

                    <Grid container spacing={1} >
                        <Grid xs={4} sm={4} md={4}  >
                            <Box sx={{ backgroundColor: CardBgColor, borderRadius: '15px', padding: { xs: '7px', sm: '7px', md: '8px' } }}>
                                <Typography sx={{ fontSize: { xs: '12px', sm: '13px' }}} color='#fff'> {props.assign_data.assign_request_day}</Typography>
                                <Typography sx={{ typography: { xs: 'h4', sm: 'h4' }, mb: -1 }} color={props.cardTheme.colors.text}>{props.assign_data.assign_request_date_only}</Typography>
                                <Box sx={ScrollTypography}> <Typography color={props.cardTheme.colors.text} sx={{ whiteSpace: 'nowrap', typography: { xs: 'body2', sm: 'body2', md: 'subtitle1' } }}  >{props.assign_data.assign_request_month_with_year}</Typography>
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', mt: 0.5 }}>
                                    <AccessTimeRoundedIcon sx={{ color: 'white', fontSize: { xs: '15px', sm: '16px', md: '20px' }, ml: '-2px', mr: 0.2 }} /> <Typography sx={{ whiteSpace: 'nowrap', typography: { xs: 'caption', sm: 'subtitle2', md: 'subtitle1' } }} color={props.cardTheme.colors.text}  > {card_request_time}</Typography>
                                </Box>
                            </Box>
                        </Grid>
                        <Grid xs={8} sm={8} md={8}>
                            {/* {(orderidBadgeShowValue !== "") ? <Stack direction='row' spacing={1} alignItems='center'>
                                <Box sx={{ width: { xs: 80, sm: 100, md: 200 } }}>
                                    <Box sx={ScrollTypography}  > <Typography variant='subtitle1' sx={{ letterSpacing: '-0.2px', whiteSpace: 'nowrap', fontWeight: 'bold' }}>{props.assign_data.assign_order_id}</ Typography></Box>
                                </Box>
                                <Chip label={<Typography variant='caption' sx={{ whiteSpace: 'nowrap' }}>{orderidBadgeShowValue}</Typography>} size="small" sx={{ backgroundColor: '#89B601', color: '#fff', borderRadius: 2, height: '18px' }} />
                            </Stack> :
                                <Box sx={{ width: { xs: 150, sm: 170, md: 300 } }}>
                                    <Box sx={ScrollTypography}> <Typography variant='subtitle1' sx={{ letterSpacing: '-0.2px', whiteSpace: 'nowrap', fontWeight: 'bold' }}>{props.assign_data.assign_order_id}</ Typography></Box>
                                </Box>} */}

<Stack direction='row' spacing={1} alignItems='center'>
<Box sx={{ width: { xs: 200, sm: 220, md: 300 } }}>
    <Box sx={ScrollTypography}><Typography variant='subtitle1' sx={{ letterSpacing: '-0.2px', whiteSpace: 'nowrap', fontWeight: 'bold',}}>{props.assign_data.assign_order_id}</Typography>
    </Box>
</Box>

{orderidBadgeShowValue !== "" && (
    <Chip label={<Typography variant='caption' sx={{ whiteSpace: 'nowrap' }}>{orderidBadgeShowValue}</Typography> } size="small" sx={{ backgroundColor: '#89B601',color: '#fff', borderRadius: 2, height: '18px'}}
    />
)}


{props.assignStatus === "action" &&
    props.assign_data.action_required_tag && (
        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
            <Chip label={ <Typography variant="caption" sx={{ whiteSpace: 'normal', width: '100%' }} >
            {props.assign_data.action_required_tag} </Typography> } size="small" sx={{ backgroundColor: props.assign_data.action_required_tag === 'Verification Required' ? '#009F96' : '#F0AD4E',color: '#fff', borderRadius: 2,height: '40px',width: '100%',justifyContent: 'flex-start'}} />
        </Box>
    )}


</Stack>

                            <Typography sx={{ letterSpacing: '-0.2px', typography: { xs: 'body2', sm: 'body1' } }} color={props.appThemeColor} >{props.assign_data.assign_industry_name}</Typography>
                            <Typography color={props.appThemeColor} sx={{ typography: { xs: 'caption', sm: 'subtitle2', md: 'subtitle1' }, whiteSpace: 'nowrap' }} style={{ letterSpacing: '-0.3px' }}  >{props.assign_data.service_type} | {props.assign_data.service_mode}</Typography>
                            <Stack direction='row'>
                                <Box sx={{ display: 'flex', alignItems: 'center', ml: '-15px' }}>
                                    <TranslateOutlinedIcon sx={{ fontSize: { xs: '15px', sm: '16px', md: '20px' }, ml: 2, mr: 0.2 }} /><Typography style={{ letterSpacing: '-1px' }} sx={{ typography: { xs: 'caption', sm: 'subtitle2', md: 'subtitle1' }, whiteSpace: 'nowrap' }} color={props.appThemeColor} >  {props.assign_data.language_name}</Typography>
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', }}>
                                    <AccessTimeRoundedIcon sx={{ fontSize: { xs: '15px', sm: '16px', md: '20px' }, ml: 2, mr: 0.2 }} /><Typography style={{ letterSpacing: '-1px' }} sx={{ typography: { xs: 'caption', sm: 'subtitle2', md: 'subtitle1' }, whiteSpace: 'nowrap' }} color={props.appThemeColor} > {props.assign_data.assign_duration}</Typography>
                                </Box>
                            </Stack>
                        </Grid>

                    </Grid>

                    {props.assignStatus === "active" && <Box >
                        <Box> <Typography sx={{ typography: { xs: 'caption', sm: 'subtitle2', md: 'subtitle1' } }} style={{ letterSpacing: '-0.4px', fontWeight: 'bold' }}> Start Time </Typography> </Box>
                        <Box> <Typography sx={{ typography: { xs: 'caption', sm: 'subtitle2', md: 'subtitle1' } }} color={props.appThemeColor} style={{ whiteSpace: 'nowrap', letterSpacing: '-0.4px' }} >{dayjs(props.assign_data.assign_start_time).format('hh:mm A [on] MM/DD/YYYY')}</Typography> </Box>
                    </Box>}

                    {(props.assignStatus === "lapsed" || (props.assignStatus === "action" && props.assign_data.page_status === "lapsed")) && <Box >
                        <Box> <Typography sx={{ typography: { xs: 'caption', sm: 'subtitle2', md: 'subtitle1' } }} style={{ letterSpacing: '-0.4px', fontWeight: 'bold' }}> Age </Typography> </Box>
                        <Box> <Typography sx={{ typography: { xs: 'caption', sm: 'subtitle2', md: 'subtitle1' } }} color={props.appThemeColor} style={{ whiteSpace: 'nowrap', letterSpacing: '-0.4px' }} > {props.assign_data.assign_lapsed_due_age}</Typography> </Box>
                    </Box>}
                    {props.assignStatus === "completed" && <Box  >

                        <Grid container spacing={1} >
                            <Grid xs={6} sm={6} md={6}  >
                                <Box> <Typography sx={{ typography: { xs: 'caption', sm: 'subtitle2', md: 'subtitle1' } }} style={{ letterSpacing: '-0.4px', fontWeight: 'bold' }}> Start Time </Typography> </Box>
                                <Box> <Typography sx={{ typography: { xs: 'caption', sm: 'subtitle2', md: 'subtitle1' } }} color={props.appThemeColor} style={{ whiteSpace: 'nowrap', letterSpacing: '-0.4px' }} >{dayjs(props.assign_data.assign_start_time).format('hh:mm A [on] MM/DD/YYYY')}</Typography> </Box>

                            </Grid>
                            <Grid xs={6} sm={6} md={6}>
                                <Box> <Typography sx={{ typography: { xs: 'caption', sm: 'subtitle2', md: 'subtitle1' } }} style={{ letterSpacing: '-0.4px', fontWeight: 'bold' }}> End Time </Typography> </Box>
                                <Box> <Typography sx={{ typography: { xs: 'caption', sm: 'subtitle2', md: 'subtitle1' } }} color={props.appThemeColor} style={{ whiteSpace: 'nowrap', letterSpacing: '-0.4px' }}> {dayjs(props.assign_data.assign_end_time).format('hh:mm A [on] MM/DD/YYYY')}</Typography> </Box>
                            </Grid>

                        </Grid>
                        <Box>

                            <Typography sx={{ typography: { xs: 'subtitle1', sm: 'subtitle1', md: 'h5' } }} style={{ fontWeight: 'bold' }} align='right' color={props.appThemeColor}  >${props.assign_data.assign_bill_value}</Typography>
                        </Box>

                    </Box>}



                </CardContent>
                <CardActions sx={{ display: 'block', padding: 0 }}>
                    <Typography align='center' style={{ fontWeight: 'normal' }} sx={{ letterSpacing: '-0.2px', typography: { xs: 'caption', sm: 'subtitle2', md: 'subtitle1' } }}   >{props.assign_data.assign_applied_timezone_daylight}</Typography>

                </CardActions>


            </Card>
        </Grid>
    )
}

export { NewRequestlist, AssignmentsStatusList }



